import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, Router, RouterLink } from '@angular/router'

import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { Yield } from '../../../abacus/interfaces/yield.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'
import { tagDefinition } from '../../tag/tag.definition'
import { toolDefinition } from '../tool.definition'
import { toolYields } from '../tool.yields'
import { Status } from '../../../common/enums/status.enum'
import { HasPermissionDirective } from '../../../abacus/directives/has-permission.directive'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { MetaComponent } from '../../../abacus/elements/partials/meta/meta.component'
import { TableComponent } from '../../../abacus/elements/partials/table/table.component'
import { PaginationComponent } from '../../../abacus/elements/partials/pagination/pagination.component'
import { EurosPipe } from 'src/app/abacus'

@Component({
    template: caseListTemplate,
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        HasPermissionDirective,
        CaseInputComponent,
        MetaComponent,
        TableComponent,
        PaginationComponent,
        EurosPipe
    ]
})
export class ToolListComponent extends CaseListComponent implements OnInit {
  definition: ResourceDefinition = toolDefinition
  yields: Yield[] = toolYields

  filters: Filter[] = [
    {
      label: 'Search a tool',
      placeholder: 'Search a tool by name or by tag...',
      properties: {
        toolIds: 'toolIds',
        tagIds: 'tagIds '
      },
      inputType: InputType.MultiSearch,
      searchResources: [toolDefinition, tagDefinition],
      className: 'is-6'
    },
    {
      label: 'Status',
      property: 'status',
      placeholder: 'All status',
      inputType: InputType.Select,
      selectOptions: [
        {
          label: 'Published',
          value: Status.Published
        },
        {
          label: 'Pending',
          value: Status.Pending
        },
        {
          label: 'Rejected',
          value: Status.Rejected
        }
      ]
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
